import React, { useState } from 'react';
import { CheckIcon, CopyIcon, LinkIcon } from 'lucide-react';
import { REFERRAL_CODE, REFERRAL_URL, trackEvent } from '../utils/tracking';
import { ReferralButton } from './ReferralButton';
import { Reveal } from './Reveal';
export function ReferralSection() {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(REFERRAL_URL);
      setCopied(true);
      trackEvent('cta_click', {
        cta_location: 'referral_card',
        cta_label: 'copiar_enlace'
      });
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };
  return <section id="referido" className="px-5 py-24 lg:px-8 lg:py-32" data-id="element-236" data-mp="3o663sy2meerj">
      <div className="mx-auto grid max-w-shell items-center gap-12 lg:grid-cols-[1fr_0.9fr] lg:gap-20" data-id="element-237" data-mp="3k3t872hl7x8h">
        <Reveal data-id="element-238" data-mp="1mc6s4bll5veb">
          <h2 className="max-w-[520px] text-[30px] font-extrabold uppercase leading-[1] tracking-tightest text-white sm:text-[42px]" data-id="element-239" data-mp="1mbxabbap2ujp">
            Regístrate con mi enlace de referido.
          </h2>
          <p className="mt-5 max-w-[460px] text-[15px] leading-relaxed text-ink-muted" data-id="element-240" data-mp="t0c4468ohey6">
            Utiliza mi enlace para comenzar tu registro en Bybit.
          </p>
          <p className="mt-6 max-w-[460px] text-[12px] leading-relaxed text-white/35" data-id="element-241" data-mp="k20b5xkca52k">
            Las recompensas y condiciones dependen del programa, campaña, región y requisitos
            vigentes.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-242" data-mp="1bu7uj5r8bvkn">
          <div className="glass glow-orange rounded-3xl p-7 lg:p-8" data-id="element-243" data-mp="1gqy8nnjh4h3f">
            <div className="flex items-center gap-2" data-id="element-244" data-mp="1gtc0lniuxd6r">
              <LinkIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-245" data-mp="12yrug6zvsk6m" />
              <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-ink-muted" data-id="element-246" data-mp="170wjstjaqung">
                Enlace de referido
              </p>
            </div>

            <div className="mt-5 flex items-center justify-between gap-4 rounded-2xl border border-brand/25 bg-black/40 px-5 py-4" data-id="element-247" data-mp="1up623lhax09u">
              <span className="text-[26px] font-extrabold tracking-[0.16em] text-brand sm:text-[30px]" data-id="element-248" data-mp="29e7psi7wmk1q">
                {REFERRAL_CODE}
              </span>
              <button type="button" onClick={copy} className="flex h-9 shrink-0 items-center gap-2 rounded-full border border-hairline px-3 text-[12px] font-medium text-ink-muted transition-colors duration-200 ease-smooth hover:border-white/25 hover:text-white" data-id="element-249" data-mp="259zycda2apzt">
                {copied ? <CheckIcon className="h-3.5 w-3.5 text-gain" aria-hidden="true" data-id="element-250" data-mp="1ln2bi7hm3ztj" /> : <CopyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-251" data-mp="1hnbdpjto4jfi" />}
                {copied ? 'Copiado' : 'Copiar'}
              </button>
            </div>

            <p className="mt-4 break-all text-[11.5px] leading-relaxed text-white/30" data-id="element-252" data-mp="17ovo5laahi84">
              {REFERRAL_URL}
            </p>

            <ReferralButton location="referral_card" size="lg" showArrow className="mt-6 w-full" data-id="element-253" data-mp="12pssgrg78oct">
              Usar mi enlace
            </ReferralButton>
          </div>
        </Reveal>
      </div>
    </section>;
}